import { type RowWrapperType, type TableAlignment } from '@lendi-jam/table';

import { HTMLFromRichText, TextFromRichText } from './PrismicTypes';

export const TABLE = 'PrismicGenericTemplateDataBodyTable';

export interface TablePrimary {
  column_1_alignment: TableAlignment;
  column_2_alignment: TableAlignment;
  column_3_alignment: TableAlignment;
  column_4_alignment: TableAlignment;
  column_5_alignment: TableAlignment;
  column_6_alignment: TableAlignment;
  table_heading: TextFromRichText;
  table_subheading: HTMLFromRichText;
}

export interface TableItem {
  row_variant: RowWrapperType;
  column_1_value: HTMLFromRichText;
  column_2_value: HTMLFromRichText;
  column_3_value: HTMLFromRichText;
  column_4_value: HTMLFromRichText;
  column_5_value: HTMLFromRichText;
  column_6_value: HTMLFromRichText;
}

export interface TableContent {
  __typename: typeof TABLE;
  items: TableItem[];
  primary: TablePrimary;
}
